"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = void 0;
var lodash_uniq_1 = __importDefault(require("lodash.uniq"));
var lodash_groupby_1 = __importDefault(require("lodash.groupby"));
var HeaderTransformer = /*#__PURE__*/function () {
  function HeaderTransformer(parserOptions) {
    _classCallCheck(this, HeaderTransformer);
    _defineProperty(this, "parserOptions", void 0);
    _defineProperty(this, "headers", null);
    _defineProperty(this, "receivedHeaders", false);
    _defineProperty(this, "shouldUseFirstRow", false);
    _defineProperty(this, "processedFirstRow", false);
    _defineProperty(this, "headersLength", 0);
    _defineProperty(this, "headersTransform", void 0);
    this.parserOptions = parserOptions;
    if (parserOptions.headers === true) {
      this.shouldUseFirstRow = true;
    } else if (Array.isArray(parserOptions.headers)) {
      this.setHeaders(parserOptions.headers);
    } else if (typeof parserOptions.headers === 'function') {
      this.headersTransform = parserOptions.headers;
    }
  }
  return _createClass(HeaderTransformer, [{
    key: "transform",
    value: function transform(row, cb) {
      if (!this.shouldMapRow(row)) {
        return cb(null, {
          row: null,
          isValid: true
        });
      }
      return cb(null, this.processRow(row));
    }
  }, {
    key: "shouldMapRow",
    value: function shouldMapRow(row) {
      var parserOptions = this.parserOptions;
      if (!this.headersTransform && parserOptions.renameHeaders && !this.processedFirstRow) {
        if (!this.receivedHeaders) {
          throw new Error('Error renaming headers: new headers must be provided in an array');
        }
        this.processedFirstRow = true;
        return false;
      }
      if (!this.receivedHeaders && Array.isArray(row)) {
        if (this.headersTransform) {
          this.setHeaders(this.headersTransform(row));
        } else if (this.shouldUseFirstRow) {
          this.setHeaders(row);
        } else {
          // dont do anything with the headers if we didnt receive a transform or shouldnt use the first row.
          return true;
        }
        return false;
      }
      return true;
    }
  }, {
    key: "processRow",
    value: function processRow(row) {
      if (!this.headers) {
        return {
          row: row,
          isValid: true
        };
      }
      var parserOptions = this.parserOptions;
      if (!parserOptions.discardUnmappedColumns && row.length > this.headersLength) {
        if (!parserOptions.strictColumnHandling) {
          throw new Error("Unexpected Error: column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length));
        }
        return {
          row: row,
          isValid: false,
          reason: "Column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length)
        };
      }
      if (parserOptions.strictColumnHandling && row.length < this.headersLength) {
        return {
          row: row,
          isValid: false,
          reason: "Column header mismatch expected: ".concat(this.headersLength, " columns got: ").concat(row.length)
        };
      }
      return {
        row: this.mapHeaders(row),
        isValid: true
      };
    }
  }, {
    key: "mapHeaders",
    value: function mapHeaders(row) {
      var rowMap = {};
      var headers = this.headers,
        headersLength = this.headersLength;
      for (var i = 0; i < headersLength; i += 1) {
        var header = headers[i];
        if (header !== undefined) {
          var val = row[i];
          if (val === undefined) {
            rowMap[header] = '';
          } else {
            rowMap[header] = val;
          }
        }
      }
      return rowMap;
    }
  }, {
    key: "setHeaders",
    value: function setHeaders(headers) {
      var _this$headers;
      var filteredHeaders = headers.filter(function (h) {
        return !!h;
      });
      if ((0, lodash_uniq_1.default)(filteredHeaders).length !== filteredHeaders.length) {
        var grouped = (0, lodash_groupby_1.default)(filteredHeaders);
        var duplicates = Object.keys(grouped).filter(function (dup) {
          return grouped[dup].length > 1;
        });
        throw new Error("Duplicate headers found ".concat(JSON.stringify(duplicates)));
      }
      this.headers = headers;
      this.receivedHeaders = true;
      this.headersLength = ((_this$headers = this.headers) === null || _this$headers === void 0 ? void 0 : _this$headers.length) || 0;
    }
  }]);
}();
exports.HeaderTransformer = HeaderTransformer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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